// Asset cache: download once per URL, return cached Blob.
// In-memory Map keyed by URL. Day 3 will add IndexedDB persistence.

interface CacheEntry {
  blob: Blob;
  objectUrl: string;
}

const cache = new Map<string, Promise<CacheEntry>>();

async function fetchAndStore(url: string): Promise<CacheEntry> {
  const res = await fetch(url, { mode: 'cors', cache: 'force-cache' });
  if (!res.ok) throw new Error(`asset fetch ${res.status}: ${url}`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  return { blob, objectUrl };
}

export function getAsset(url: string): Promise<CacheEntry> {
  let p = cache.get(url);
  if (!p) {
    p = fetchAndStore(url);
    cache.set(url, p);
  }
  return p;
}

export function clearCache(): void {
  for (const p of cache.values()) {
    p.then((e) => URL.revokeObjectURL(e.objectUrl)).catch(() => {});
  }
  cache.clear();
}
